export default "/assets/images/badge-01.webp?c3d26e4174b9bcf6b270cde0f8c756d6";